import { Image } from './image';
import { Entity } from './entity';
import { environment } from '../../environments/environment';

export class Book extends Entity {

    name: string;
    link: string;
    thumbnailCover: Image;

    getEndpointName(): string {
        return environment.endpointUrls.usedBooks;
    }

}
